import z from 'zod';
import {base64ObjectSchema} from '../_other/base64ObjectSchema';

/**
 * Request payload for create-flashcard-by-CSV callable.
 * csvFile is a Base64Object (convert to File via base64ObjectToFile from @coolcolduk/util).
 */
export const flashcardCreateByCsvRequestSchema = z.object({
  csvFile: base64ObjectSchema,
  title: z.string().min(1, 'Title is required'),
});

export interface FlashcardCreateByCsvRequest extends z.infer<typeof flashcardCreateByCsvRequestSchema> {}
